import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-list-table',
  templateUrl: './list-table.component.html',
  styleUrls: ['./list-table.component.scss']
})
export class ListTableComponent implements OnInit {

  @Input() type;

  constructor() { }

  ngOnInit() {
  }

}
